import { isCashBalanceEnabled } from './planDesign.js'
export const BASE_PEOPLE_INPUT_COLUMN_COUNT = 23

export function hasEnabledCashBalancePlan(plans = []) {
  return plans.some((plan) => isCashBalanceEnabled(plan))
}

export function peopleInputColumnCount({ showCbColumns = false } = {}) {
  return BASE_PEOPLE_INPUT_COLUMN_COUNT
    + (showCbColumns ? 3 : 0)
}
